module.exports = __webpack_public_path__ + "img/partner_logo05.00da4a1f.png";